"use client";

import { useLocale, useTranslations } from "next-intl";

import { getWayflyerEventsForLocale } from "@/content/shared/events";
import type { SupportedLocale } from "@/i18n/routing";

import { NAV_PREVIEW_SUBNAV_GRADIENT } from "./nav-preview-blue-gradient";
import { NavPreviewSubnav } from "./nav-preview-subnav";
import { NavPreviewFrame } from "./preview-frame";

const MAX_PREVIEW_EVENTS = 4;

export function ResourcesEventsNavPreview() {
  const t = useTranslations("Nav.preview.events");
  const locale = useLocale() as SupportedLocale;

  const links = getWayflyerEventsForLocale(locale)
    .filter((event) => event.url)
    .slice(0, MAX_PREVIEW_EVENTS)
    .map((event) => ({
      label: event.name,
      href: event.url!,
      external: event.external,
    }));

  return (
    <NavPreviewFrame
      className={NAV_PREVIEW_SUBNAV_GRADIENT}
      contentClassName="items-start justify-start p-0 pr-3 pl-[48px] pt-[32px]"
    >
      <NavPreviewSubnav
        className="w-[334px]"
        columnGap="gap-6"
        linkGap="gap-4"
        label={t("label")}
        columns={1}
        links={links}
        footerLink={{ label: t("viewAll"), href: "/events" }}
      />
    </NavPreviewFrame>
  );
}
